import React from 'react';

const StartupAdmin = () => {
  return (
    <div className="section-gap">
      <div className="card">
        <h2 className="text-xl heading mb-4">Startup Administration</h2>
        <p className="text-muted">Admin controls for startup management.</p>
      </div>
    </div>
  );
};

export default StartupAdmin;
